import React, { useState, useEffect, useRef } from 'react'
import clsx from 'clsx'

interface ExpandableTextProps {
    text: string
    maxLines?: number
    className?: string
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
    text,
    maxLines = 3,
    className,
}) => {
    const [expanded, setExpanded] = useState(false)
    const [isOverflowing, setIsOverflowing] = useState(false)
    const textRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const el = textRef.current
        if (el && !expanded) {
            requestAnimationFrame(() => {
                setIsOverflowing(el.scrollHeight > el.clientHeight)
            })
        }
    }, [text, maxLines, expanded])

    if (!text) return null

    return (
        <div className={clsx('text-sm', className)}>
            <div
                ref={textRef}
                className={clsx({
                    [`line-clamp-${maxLines}`]: !expanded,
                    'overflow-hidden': !expanded,
                })}
            >
                {text}
            </div>

            {isOverflowing && (
                <button
                    onClick={() => setExpanded((prev) => !prev)}
                    className="text-gray-400 hover:text-blue-600 mt-1"
                >
                    {expanded ? 'Show less' : '... see more'}
                </button>
            )}
        </div>
    )
}

export default ExpandableText
